export const SET_MAILS = "MAILS_SET_MAILS";
export const PUSH_MAILS = "MAILS_PUSH_MAILS";
export const SET_LASTID = "MAILS_SET_LASTID";
export const SET_ERROR = "MAILS_SET_ERROR";
export const SET_FETCHING = "MAILS_SET_FETCHING";
export const SET_SEARCH = "MAILS_SET_SEARCH";
